<div class="col-xs-12">
    <form novalidate class="form-inline" [formGroup]="form" (submit)="onSubmit($event)">
        <input class="form-control" [formControl]="form.get('pagePath')" />
        <button [ladda]="isLoading" type="submit" class="btn btn-sm btn-primary button-with-icon ml-2">
            {{ 'addSitePage' | translate }}
        </button>
    </form>
    <div [val-messages]="form.get('pagePath')">
        <span val-message="required">{{ 'pagePathRequired' | translate }}</span>
        <span val-message="validatePagePath">{{ 'invalidPagePath' | translate }}</span>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/site/add-page/add-page.component.html